/**
 * node.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export type NodeIdentifier = number;

export class GraphNode
{
    public label? : string;
    // public category? : string;

    // values for D3 simulation
    public index? : number;
    public x : number;
    public y : number;
    public vx : number;
    public vy : number;
    public fx? : number;
    public fy? : number;

    public simulated : boolean = false;
    public enabled : boolean = true;

    constructor (
      public id : NodeIdentifier,
      public category : string = "none"
    ) {}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/graphs/node.ts